export default {
  english: {
    partnerSubscription: 'Partner subscription',
    newsletterSubscription: 'Newsletter subscription',
    preferences: 'Preferences and options',
    error: 'An error occurred, please retry',
    success: 'Your modifications have been saved',
  },
  french: {
    partnerSubscription: 'Offres partenaires',
    newsletterSubscription: 'Abonnement newsletter',
    preferences: 'Préférences et options',
    error: 'Une erreur est survenue, veuillez réessayer',
    success: 'Vos modifications ont été sauvegardées',
  },
  arabic: {
    partnerSubscription: 'اشتراك الشريك',
    newsletterSubscription: 'رسائل اخبارية ',
    preferences: 'التفضيلات والخيارات',
    error: 'وقع خطأ يرجى اعادة المحاولة',
    success: 'تم حفظ التعديلات الخاصة بك',
  },
  hebrew: {
    partnerSubscription: 'מנוי שותף',
    newsletterSubscription: 'הרשמה לניוזלטר',
    preferences: 'העדפות ואפשרויות',
    error: 'אירעה שגיאה, אנא נסה שנית',
    success: 'השינויים שלך נשמרו',
  },
  persian: {
    partnerSubscription: 'اشتراک شریک',
    newsletterSubscription: 'اشتراک خبرنامه',
    preferences: 'اولویت ها و گزینه ها',
    error: 'خطایی روی داد، لطفا دوباره امتحان کنید',
    success: 'تغییرات شما ذخیره شده است',
  },
}
